import { toast } from "react-toastify";
import { BAD_FIT, COMMON } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

/** GET `ai-recruiter/bad-fit/metadata` — table columns + filter definitions. */
export const getBadFitMetadata = async () => {
    try {
        const response = await GET(BAD_FIT.GET_METADATA);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** POST `ai-recruiter/bad-fit/filter` — paged bad fit list. */
export const submitBadFitFilterData = async (data = {}) => {
    try {
        const response = await POST(BAD_FIT.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** GET `common/bad-fit-resolution-reasons` — resolution reason dropdown options. */
export const fetchCommonBadFitResolutionReasons = async () => {
    try {
        const response = await GET(COMMON.BAD_FIT_RESOLUTION_REASONS);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const mapBadFitResolutionReasonOptionsFromResponse = (response) => {
    const data = response?.data;
    const rows = Array.isArray(data?.records)
        ? data.records
        : Array.isArray(data)
          ? data
          : [];
    return rows
        .map((row) => {
            const value = String(row?.id ?? row?.value ?? "").trim();
            const label = String(row?.reason ?? row?.display ?? row?.label ?? "").trim();
            if (!value || !label) return null;
            return { value, label };
        })
        .filter(Boolean);
};

/** GET `ai-recruiter/bad-fit/tracking/{trackingId}` — load bad fit tracking details. */
export const fetchBadFitTrackingDetails = async (trackingId) => {
    try {
        const id = String(trackingId ?? "").trim();
        if (!id) {
            toast.error("Bad fit tracking ID is required to load details.");
            return null;
        }
        const response = await GET(BAD_FIT.TRACKING_BY_ID(id));
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** POST `ai-recruiter/bad-fit/{candidateClientId}/resolve` — resolve bad fit. */
export const resolveBadFitForCandidate = async (candidateClientId, data = {}) => {
    try {
        const id = String(candidateClientId ?? "").trim();
        if (!id) {
            toast.error("Candidate ID is required to resolve bad fit.");
            return null;
        }
        const badFitResolutionReasonMasterId = String(
            data?.badFitResolutionReasonMasterId ?? ""
        ).trim();
        const note = String(data?.note ?? "").trim();
        if (!badFitResolutionReasonMasterId) {
            toast.error("Please select a resolution reason.");
            return null;
        }
        const response = await POST(BAD_FIT.RESOLVE(id), {
            badFitResolutionReasonMasterId,
            note,
        });
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
